// api/index.js
import request from '../util/request'

export function getNoteList(params) {
    return request({
        url: '/front/api/design/note/list',
        method: 'get',
        params,
    })
}

export function getTemplate(tempId) {
    return request({
        url: `/front/api/design/temp/${tempId}`,
        method: 'get',
    })
}

export function saveTemplate(data) {
    return request({
        url: '/front/api/design/temp/save',
        method: 'post',
        data,
    })
}

export function listProduct(data) {
    return request({
        url: '/front/api/design/product/list',
        method: 'get',
        params: data,
    })
}

export function listProductCate(data) {
    return request({
        url: '/front/api/design/productCate/list',
        method: 'get',
        params: data,
    })
}

export function listProductCateTree(data) {
    return request({
        url: '/front/api/design/cate/tree',
        method: 'get',

    })
}

export function updateFileByForm(form) {
    return request({
        url: '/front/api/common/oss/upload',
        method: 'post',
        data: form,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export function getUpdateFileUrl(objectName, prefix) {
    return request({
        url: '/front/api/common/oss/uploadByUrl?objectName=' + objectName + '&prefix=' + prefix,
        method: 'post',
    })
}export function uploadNoLoginByUrl(objectName, prefix) {
    return request({
        url: '/front/api/common/oss/uploadNoLoginByUrl?objectName=' + objectName + '&prefix=' + prefix,
        method: 'post',
    })
}

export function getPicList(params) {
    return request({
        url: '/front/api/design/pic/list',
        method: 'get',
        params: params,

    })
}

export function getConfig() {
    return request({
        url: '/front/api/design/conf/list',
        method: 'get',

    })
}

export function savaPicList(data) {
    return request({
        url: '/front/api/design/pic/batchSave',
        method: 'post',
        data,

    })
}

export function getNoteById(id) {
    return request({
        url: '/front/api/design/note/' + id,
        method: 'get',

    })
}

//ɾ���̻�ģ��
export function deleteShopTempById(id) {
    return request({
        url: '/front/api/design/shoptemp/' + id,
        method: 'delete',

    })
}

// ��ѯ��Ʒ��Ŀ������ϸ
export function getProduct(id) {
    return request({
        url: '/front/api/design/product/' + id,
        method: 'get',
    })
}

// ������Ʒ��Ŀ����
export function addProduct(data) {
    return request({
        url: '/front/api/design/product',
        method: 'post',
        data: data,
    })
}

// �޸���Ʒ��Ŀ����
export function updateProduct(data) {
    return request({
        url: '/front/api/design/product',
        method: 'put',
        data: data,
    })
}

export function removeByNote(id, params) {
    return request({
        url: '/front/api/design/shoptemp/removeByNote/' + id,
        method: 'delete',
        params: params,
    })
}

export function updateNote(data) {
    return request({
        url: '/front/api/design/note',
        method: 'post',
        data: data,
    })
}

export function deleteNoteById(id) {
    return request({
        url: '/front/api/design/note/' + id,
        method: 'delete',
    })
}

export function listCompareGroup(productId) {
    return request({
        url: '/front/api/design/compare/list?productId=' + productId,
        method: 'get',
    })
}

export function getCompareGroup(id) {
    return request({
        url: '/front/api/design/compare/getById?id=' + id,
        method: 'get',
    })
}

export function delCompareGroup(id) {
    return request({
        url: '/front/api/design/compare/delete?id=' + id,
        method: 'delete',
    })
}

export function editCompareGroup(data) {
    return request({
        url: '/front/api/design/compare/edit',
        method: 'post',
        data: data,
    })
}
export function getShop(id) {
    return request({
        url: '/front/api/design/shop/' + id,
        method: 'get'
    })
}
